// extracted by mini-css-extract-plugin
module.exports = {"avatar-disabled":"styles-module__avatar-disabled___2aRVP"};